import { Paper, Typography } from '@mui/material';

import { Welcome } from './01-Welcome';
import { useSelector } from 'react-redux';
import { RegistrationComplete } from './05-RegistrationComplete';
import { InvalidInvitation } from './06-InvalidInvitation';
import { ThermsAndConditions } from './04-ThermsAndConditions';
import { ChoosePassword } from './03-ChoosePassword';
import { EnterPhone } from './02-EnterPhone';
import { RegistrationLegalAdminComplete } from './07-RegistrationLegalAdminComplete';
import { useTranslation } from 'react-i18next';

export function RegistrationStepper() {
  const { t } = useTranslation();
  const activeStep = useSelector((state) => state.GlobalReducer.currentRegistrationStep);
  const steps = [<Welcome />, <EnterPhone />, <ChoosePassword />, <ThermsAndConditions />, <RegistrationComplete />, <InvalidInvitation />, <RegistrationLegalAdminComplete />];
  const stepTitles = ['welcome', 'enter_phone_title', 'enter_password_title', 'therms_and_conditions_title', 'registration_complete_title', 'invalid_invitation_title', 'registration_complete_title'];

  return (
    <Paper sx={{ width: 600, padding: 5, margin: 'auto' }}>
      <Typography variant="h4" align="center" sx={{ marginBottom: 10 }} color="primary">
        {t(stepTitles[activeStep])}
      </Typography>
      {steps[activeStep]}
    </Paper>
  );
}
